import { Grid } from '@mui/material'

import { useGetPriceLevels } from '../../hooks/useGetPriceLevels/useGetPriceLevels'
import { CustomerInformation, PriceLevelEntry } from '../../sdk'
import { DetailPanelGridItem } from './DetailPanelGridItem'
interface Props {
  customerInfo: CustomerInformation
}

export function getCustomerFieldValue(
  customerInfo: CustomerInformation,
  fieldTitle: string,
  priceLevelOptions: PriceLevelEntry[]
): string {
  const value = customerInfo[fieldTitle as keyof CustomerInformation]
  const booleanFields = new Set(['taxExempt', 'marketingOptOut'])
  if (booleanFields.has(fieldTitle)) {
    return value ? 'Yes' : 'No'
  }
  if (fieldTitle === 'defaultPriceLevel' && value) {
    return priceLevelOptions.find((o) => o.id === value)?.info?.name || ''
  }
  return (value as string) || ''
}

export const CustomerDetailPanel = ({ customerInfo }: Props) => {
  const { nonArchivedPriceLevelEntries } = useGetPriceLevels(
    customerInfo.defaultPriceLevel ? [customerInfo.defaultPriceLevel] : []
  )

  return (
    <Grid container aria-label="customerDetailPanel">
      {[
        'firstname',
        'lastname',
        'companyName',
        'streetAddress',
        'city',
        'state',
        'zipcode',
        'source',
        'defaultPriceLevel',
        'taxExempt',
        'marketingOptOut'
      ].map((fieldTitle) => (
        <DetailPanelGridItem
          key={fieldTitle}
          fieldTitle={fieldTitle}
          fieldValue={getCustomerFieldValue(
            customerInfo,
            fieldTitle,
            nonArchivedPriceLevelEntries
          )}
        />
      ))}
    </Grid>
  )
}
